export const OMNITURE_URL_ARGS = 'source=SEO_City_Template';
export const OMNITURE_AIRPORT_URL_ARGS = 'source=SEO_Airport_Template';

export const CASE_CAB_CARD = '&case=cab_card';
export const CASE_OTHERS = '&case=others';
export const CASE_LEAVE_INTENT = '&case=leave_intent';
export const CASE_SEARCH_WIDGET = '&case=search_widget';
